// Required by src/engines/frontend_core/angular/customer_application_bootstrap/index.js

require('angular/libs/avant/customer_applications/directives');
require('angular/libs/avant/trackingPixel/trackingPixel.coffee');
require('angular/libs/avant/kenshooReporter/kenshooReporterDirective.coffee');
require('angular/libs/avant/conditionalAutoFocus/conditionalAutoFocus.coffee');
require('angular/libs/avant/autocomplete/autocompleteList.coffee');
require('angular/libs/avant/autocomplete/autocompleteItem.coffee');
require('angular/libs/avant/scriptTags/index.js');
